<template>
    <div class="p-t-xs-20 p-b-xs-20">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="button__group m-b-xs-20">
                        <ak-button
                            size="small"
                            @click="backToGrid"
                        >
                            <i class="ak-icon ak-button__icon">arrow_left</i>
                            {{$t('Ga naar lijst')}}
                        </ak-button>
                        <ak-button
                            v-if=" ! data.transactionOk || data.settlement.isHandled"
                            size="small"
                            @click="goToNext"
                        >
                            {{$t('Ga naar volgende')}}
                            <i class="ak-icon ak-button__icon">arrow_right</i>
                        </ak-button>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div v-if="!loading" class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div
                            class="ak-panel__header ak-panel__header--small"
                            :class="[
                                {'ak-panel__header--success': data.transactionOk},
                                {'ak-panel__header--warning': ! data.transactionOk},
                            ]"
                        >
                            <div class="ak-panel__title">
                                {{ $t('Terugbetaling Mollie') }} <strong>{{ data.settlement.settledAt | date-relative }}</strong> (<a :href="`https://www.mollie.com/dashboard/org_7791761/administration/settlements/${ data.settlement.mollieId }`" target="_blank">{{ data.settlement.mollieId }}</a>)
                            </div>
                        </div>
                        <div class="ak-panel__body ak-panel__body--small reading">
                            <div v-if="true || data.transactionOk">
                                <p>
                                    <i class="fa fa-check"></i>
                                    {{ $t('Aantal Mollie betaaltransacties matcht met het aantal verkoopsfacturen in Exact Online.') }}
                                </p>
                                <p v-if="data.settlement.dateHandled">
                                    <i class="fa fa-check"></i>
                                    {{ $t('Import bevestigd op @date door @admin', {'@date': dateHandledForDisplay, '@admin': data.settlement.adminName}) }}
                                </p>
                                <p class="text-muted small">
                                    {{ $t('Gesynchroniseerd vanuit Mollie:') }}
                                    <i class="fa fa-eur"></i> {{ data.settlement.amountForAdmin }}
                                    <i class="fa fa-credit-card"></i> {{ $t('@amount betalingen', {'@amount': data.settlement.totalPayments}) }}
                                </p>
                                <ak-button
                                    v-if=" ! data.settlement.isHandled"
                                    @click.prevent="exportTransaction">
                                    {{ $t('Download als MT940') }}
                                </ak-button>
                                <template v-if=" ! data.settlement.isHandled">
                                    <hr />
                                    <ak-checkbox
                                        v-model="isHandled"
                                        :id="isHandled"
                                        :hasError="hasError"
                                        :error="$t(error)"
                                        :title="$t('Is geimporteerd in Exact Online?')"
                                    />
                                    <ak-button
                                        colorMode="secondary"
                                        @click="submitForm"
                                    >
                                        {{ $t('Importeren bevestigen') }}
                                    </ak-button>
                                </template>
                            </div>
                            <div v-else>
                                <div class="text-muted">
                                    <i class="fa fa-warning"></i>
                                    {{ $t('Aantal Mollie betaaltransacties komt niet overeen met het aantal verkoopsfacturen in Exact Online.') }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <ak-loader size="large" :loading="loading" />
                </div>
                <div class="col-lg-4">
                    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Nog te verwerken terugbetaligen') }}
                            </div>
                        </div>
                        <div class="ak-panel__body ak-panel__body--small reading">
                            {{ data.totalToDo }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MollieDetails',
    data() {
        return {
            data: null,
            isHandled: false,
            hasError: false,
            error: null,
            loading: false,
        }
    },
    watch: {
        '$route.params.hashId': {
            handler () {
                this.initialize();
            }
        }
    },
    computed: {
        settledAt() {
            return data.settlement.settledAt;
        },
    },
    methods: {
        async initialize() {
            this.loading = true;
            this.isHandled = false;
            this.hasError = false;
            this.error = null;
            const result = await this.$get('/mollie-details/' + this.$route.params.hashId);
            if (result.success) {
                this.data = result.data;
            }

            this.loading = false;
        },
        backToGrid() {
            this.$router.push({name: 'grid', params:{bundle: 'mollie-settlement', gridDefinition: 'grid'}});
        },
        goToNext() {
            if (this.data.nextSettlement) {
                this.$router.replace({name: 'mollie-details', params:{hashId: this.data.nextSettlement.hashId}});
            } else {
                this.backToGrid();
            }
        },
        exportTransaction() {
            window.location.href = this.$generateUrl('/mollie-details/download/' + this.$route.params.hashId);
        },
        async submitForm() {
            if ( ! this.isHandled) {
                this.hasError = true;
                this.error = 'Gelieve dit veld niet leeg te laten.';
                return;
            }

            const result = await this.$get('/mollie-details/submit/' + this.$route.params.hashId);
            if (result.success) {
                this.goToNext();
            }
        }
    },
    created() {
        this.initialize();
    }
}
</script>
